<script>
    let { value } = $props();

    let data = $derived(value);


</script>
<style>

</style>
{#if data}
    <span title={data}>{data}</span>
{/if}